var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskPortfolioBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,28.216H50.4q15.447,0,23.175,6.375T81.3,54.615q0,9.753-3.375,15.226a22.932,22.932,0,0,1-9.974,8.625q16.5,5.7,16.5,24.45,0,15.6-8.25,22.35t-23.85,6.75H12.75Zm37.2,10.2H24.3v35.85H51q9.6,0,14.026-4.576t4.424-13.8q0-9.226-4.725-13.35T49.95,38.416Zm1.2,45.9H24.3v37.5H51.9q10.2,0,15.524-4.274t5.326-15.075a19.489,19.489,0,0,0-2.175-9.6,12.627,12.627,0,0,0-5.776-5.55A32.655,32.655,0,0,0,51.15,84.315Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2,132.016v-75h11.1v10.2a73.086,73.086,0,0,1,27.45-11.851v11.4a80.877,80.877,0,0,0-13.125,3.75,87.237,87.237,0,0,0-10.425,4.5l-3.75,1.95v55.05Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.6,122.716l4.351-.45.3,8.849a215.525,215.525,0,0,1-29.25,2.4q-16.2,0-22.951-9.375T144.3,94.966q0-39.45,31.35-39.45,15.15,0,22.65,8.474t7.5,26.625l-.6,8.551H155.7q0,12.452,4.5,18.449t15.675,6Q187.047,123.615,198.6,122.716Zm-4.05-32.55q0-13.8-4.424-19.5t-14.4-5.7q-9.976,0-15,6t-5.175,19.2Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,79.666v38.4q.45,5.553,8.7,6.6l-.451,8.85q-11.85,0-17.849-6a65.986,65.986,0,0,1-27,6q-10.352,0-15.75-5.85t-5.4-16.8q0-10.947,5.55-16.125t17.4-6.375l23.549-2.25V79.666q0-7.651-3.3-10.95t-9-3.3a215.9,215.9,0,0,0-24.9,1.5l-4.649.449-.45-8.55a151.3,151.3,0,0,1,29.25-3.3q12.747,0,18.524,5.849T273.3,79.666Zm-46.2,30.6q0,13.8,11.4,13.8a60.635,60.635,0,0,0,20.1-3.45l3.45-1.2V94.666l-22.2,2.1q-6.75.6-9.75,3.9T227.1,110.266Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.546,55.516a129.547,129.547,0,0,1,16.8,1.8l3.6.451-.45,9.15a176.08,176.08,0,0,0-17.7-1.351q-12.75,0-17.324,6.076t-4.575,22.5q0,16.425,4.274,22.875t17.776,6.45l17.7-1.351.45,9.3a154.612,154.612,0,0,1-20.85,2.1q-17.552,0-24.225-9t-6.675-30.375q0-21.375,7.2-30T320.546,55.516Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.145,132.016H354.9V24.315h11.25v36.9q12-5.7,23.1-5.7,15,0,20.174,8.1t5.175,28.8v39.6h-11.25v-39.3q0-15.6-3.075-21.375T387.3,65.565A49.972,49.972,0,0,0,369,69.016l-2.851,1.049Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.943,92.266v39.75h-11.55V28.216h38.4q16.5,0,24.825,7.649t8.325,23.851q0,24-19.05,30.149l19.95,42.151h-12.75l-18.75-39.75Zm27-10.2q21.15,0,21.15-21.825t-21.3-21.824h-26.85V82.065Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.842,40.065V27.016h11.25V40.065Zm0,91.951v-75h11.25v75Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.242,65.565q-16.351,0-16.35,11.4,0,5.252,3.75,7.425t17.1,4.5q13.349,2.326,18.9,6.525t5.55,15.75q0,11.552-7.425,16.949t-21.675,5.4a135.889,135.889,0,0,1-21.9-2.1l-4.5-.75.6-9.75q17.1,2.552,25.8,2.55t13.275-2.776q4.575-2.772,4.575-9.3t-3.9-8.85q-3.9-2.325-17.1-4.426t-18.75-6.149q-5.55-4.05-5.55-15t7.725-16.2q7.724-5.248,19.275-5.25a158.017,158.017,0,0,1,22.95,2.1l4.2.75-.3,9.6A195.438,195.438,0,0,0,575.242,65.565Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.691,132.016h-11.25V24.315h11.25v63.6l11.7-.6,21.45-30.3h12.75l-24.45,34.5,25.5,40.5h-12.75l-22.349-34.8-11.851.45Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.862,26.655v-4.6h18.4v4.6H697.19V49.472h-5.061V26.655Zm21.252,22.908V22.056h6.624l6.072,19.135,6.531-19.135h6.441V49.563H727V28.956l-6.073,19.228H716.97L710.9,28.956V49.563Z",
    style: {
      fill: "#4b4c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.6,105.3H813.8V135H793.1V33h37.5q36.3,0,36.3,35.4,0,17.853-9.225,27.375T830.6,105.3ZM813.8,87.6h16.65q15.447,0,15.45-19.2,0-9.449-3.75-13.575t-11.7-4.125H813.8Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.523,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.667-27.773t6.667-28.088q6.667-9.186,22.943-9.187t22.942,9.187q6.667,9.191,6.667,28.088T924.523,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T913.13,80.82q-3.149-5.88-11.549-5.88t-11.55,5.88q-3.15,5.882-3.151,18.848T889.978,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.969,111.061V135h-14.49V63.6H969.2q25.2,0,25.2,23.519,0,13.966-10.5,20.58L994.084,135H978.229l-8.294-23.939Zm21.106-15.54a12.89,12.89,0,0,0,2.519-8.3,11.964,11.964,0,0,0-2.677-8.191q-2.678-3.043-7.717-3.045H955.969V98.67H969.41Q974.552,98.67,977.075,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.074,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.607,135V63.6h45.57V76.2H1072.1v21h25.41v12.6H1072.1V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.664,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.668-27.773t6.668-28.088q6.668-9.186,22.943-9.187t22.942,9.187q6.666,9.191,6.667,28.088T1160.664,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.151-18.848q-3.149-5.88-11.549-5.88t-11.55,5.88q-3.152,5.882-3.151,18.848T1126.119,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.255,135H1177.62V63.6h14.49V122.19h26.145Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.079,135V63.6h14.489V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.411,127.388q-6.669,8.874-22.942,8.872t-22.943-8.872q-6.669-8.871-6.668-27.773t6.668-28.088q6.667-9.186,22.943-9.187t22.942,9.187q6.666,9.191,6.667,28.088T1302.411,127.388Zm-34.545-9.241q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479t-3.15-18.848q-3.15-5.88-11.55-5.88t-11.55,5.88q-3.152,5.882-3.15,18.848T1267.866,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskPortfolioBanner);
export default __webpack_public_path__ + "static/media/BreachRisk_Portfolio_Banner.f69f44361b1b40646947a709a77fe467.svg";
export { ForwardRef as ReactComponent };